import { IAddress } from './address';

export enum FacilityType {
  WAREHOUSE = 'WAREHOUSE',
  STORE = 'STORE',
  VENDOR = 'VENDOR',
}

export interface IFacility {
  id: number;
  name: string;
  address: IAddress;
  facilityType: FacilityType;
  vendorId: number;
  enabled: boolean;
  grnEnabled: boolean;
  unicomFacilityCode: string;
  jitInvSyncEnabled: boolean;
  billToFacilityId: number;
  defaultPOFacilityId: number;
  gstin: string;
  storeSizeInSqFt: number;

  cloudflareVideoId?: string;

  addressLine1?: string;
  addressLine2?: string;
  contactPhone?: string;
  displayLocation?: string;
  mapUrl?: string;
  timings?: string;
  imageUrl?: string;
  onlineSaleable?: boolean;
  expressDeliveryZone?: string;
  expressServiceabilityEnabled?: boolean;
  jitB2b2cExpressEnabled?: boolean;
  expressPriorityRank?: number;
  config?: Record<string, unknown>;
}
